import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: { // Exercise num
    unit: 'Unit 5',
    id: 'SB3-U5-P39-E1',
    audio: 'img/FriendsPlus/Page39/Audio/audio-e1-p39.mp3',
    video: '',
    component: T6,
    exerciseKey: 'img/FriendsPlus/Page39/E1/Key/answerKey.png',
    stylesTextInput: { borderBottomWidth: 0, backgroundColor: 'transparent' },
    titleQuestion: [{ num: '1', title: 'Listen and match. <headphone name="59" src="img/FriendsPlus/Page39/Audio/tieude-e1-p39.mp3"></headphone>', color: "#1F4199" }],
    inputSize: 34,
    maxLength: 1,
    textAlign: 'center',
    titleImage: "",
    questionImage: [],
    questions: [
      {
        title: `
          <div style='padding: 20px;position: relative;'>
            <div>
              <img src="img/FriendsPlus/Page39/E1/title.jpg" >
            </div>
            <div>
              <div style='display:flex;justify-content: space-between; position: absolute; top: 142px; left: 399px;'><input id='0' /></div>
              <div style='display:flex;justify-content: space-between; position: absolute; top: 142px; left: 649px;'><input id='1' /></div>
              <div style='display:flex;justify-content: space-between; position: absolute; top: 142px; left: 886px;'><input id='2' /></div>
            </div>
          </div>
        `,
        answer: ['c', 'a', 'd'],
      },
    ],
  },
  2: { // Exercise num
    unit: "Unit 5",
    id: "SB3-U5-P39-E2",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page39/E2/1.jpg" }]],
  },


  3: { // Exercise num
    unit: "Unit 5",
    id: "SB3-U5-P39-E3",
    audio: "",
    video: "",
    component: D1,
    exerciseKey: "",
    hideBtnFooter: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page39/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page39/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/3.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page39/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/6.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page39/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/9.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E3/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page39/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/12.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E3/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page39/E3/14.jpg' },
      ],
    ],
  },
  4: { // Exercise num
    unit: "Unit 5",
    id: "SB3-U5-P39-E4",
    audio: "",
    video: "",
    component: D1,
    exerciseKey: "",
    hideBtnFooter: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [{ url: 'img/FriendsPlus/Page39/E4/1.jpg' }],
      [{ url: 'img/FriendsPlus/Page39/E4/2.jpg' }],
      // [{ url: 'img/FriendsPlus/Page39/E4/3.jpg'}],
      [
        // Column4
        { url: 'img/FriendsPlus/Page39/E4/4.jpg' },
        { url: 'img/FriendsPlus/Page39/E4/5.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E4/6.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page39/E4/7.jpg' },
        { url: 'img/FriendsPlus/Page39/E4/8.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E4/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page39/E4/10.jpg' },
        { url: 'img/FriendsPlus/Page39/E4/11.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E4/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page39/E4/13.jpg' },
        { url: 'img/FriendsPlus/Page39/E4/14.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E4/15.jpg' },
      ],
    ],
  },
}

export default json;
